jQuery(function ($) {
  lightbox.option({
    disableScrolling: true,
    alwaysShowNavOnTouchDevices: true,
  });

  // Move caption to the bottom of the image container
  $(document).on('shown.bs.lightbox', function () {
    const $caption = $('.lb-details');
    const $imageContainer = $('.lb-outerContainer');

    if ($caption.length && $imageContainer.length) {
      $caption.appendTo($imageContainer);
    }
  });

  // Alternative: Listen for lightbox changes via MutationObserver
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        const $caption = $('.lb-details');
        const $imageContainer = $('.lb-outerContainer');

        if ($caption.length && $imageContainer.length && !$imageContainer.find('.lb-details').length) {
          $caption.appendTo($imageContainer);
        }
      }
    });
  });

  // Start observing when lightbox opens
  $(document).on('click', '[data-lightbox]', function() {
    setTimeout(function() {
      const lightboxOverlay = document.querySelector('.lightbox');
      if (lightboxOverlay) {
        observer.observe(lightboxOverlay, { childList: true, subtree: true });
      }
    }, 100);
  });

  $('.expand-gallery').on('click', function () {
    const galleryId = $(this).data('target');
    const gallery = document.querySelector(`a[data-lightbox="${galleryId}"]`);

    if (gallery) {
      const $gallery = $(gallery);

      lightbox.start($gallery);

      // Move caption after lightbox opens
      setTimeout(function() {
        const $caption = $('.lb-details');
        const $imageContainer = $('.lb-outerContainer');

        if ($caption.length && $imageContainer.length) {
          $caption.appendTo($imageContainer);
        }
      }, 100);
    }
  });
});
